import { mutate } from './use-swr';
import hash from './libs/hash';

var Cache =
/** @class */
function () {
  function Cache(initialData) {
    if (initialData === void 0) {
      initialData = {};
    }

    this.__cache = new Map(Object.entries(initialData));
    this.__listeners = [];
  }

  Cache.prototype.get = function (key) {
    var _key = this.serializeKey(key)[0];
    return this.__cache.get(_key);
  };

  Cache.prototype.set = function (key, value, shouldNotify) {
    if (shouldNotify === void 0) {
      shouldNotify = true;
    }

    var _key = this.serializeKey(key)[0];

    this.__cache.set(_key, value);

    if (shouldNotify) mutate(key, value, false);
    this.notify();
  };

  Cache.prototype.keys = function () {
    return Array.from(this.__cache.keys());
  };

  Cache.prototype.has = function (key) {
    var _key = this.serializeKey(key)[0];
    return this.__cache.has(_key);
  };

  Cache.prototype.clear = function (shouldNotify) {
    if (shouldNotify === void 0) {
      shouldNotify = true;
    }

    if (shouldNotify) this.__cache.forEach(function (key) {
      return mutate(key, null, false);
    });

    this.__cache.clear();

    this.notify();
  };

  Cache.prototype.delete = function (key, shouldNotify) {
    if (shouldNotify === void 0) {
      shouldNotify = true;
    }

    var _key = this.serializeKey(key)[0];
    if (shouldNotify) mutate(key, null, false);

    this.__cache.delete(_key);

    this.notify();
  }; // TODO: introduce namespace for the cache


  Cache.prototype.serializeKey = function (key) {
    var args = null;

    if (typeof key === 'function') {
      try {
        key = key();
      } catch (err) {
        // dependencies not ready
        key = '';
      }
    }

    if (Array.isArray(key)) {
      // args array
      args = key;
      key = hash(key);
    } else {
      // convert null to ''
      key = String(key || '');
    }

    var errorKey = key ? 'err@' + key : '';
    return [key, args, errorKey];
  };

  Cache.prototype.subscribe = function (listener) {
    var _this = this;

    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    var isSubscribed = true;

    this.__listeners.push(listener);

    return function () {
      if (!isSubscribed) return;
      isSubscribed = false;

      var index = _this.__listeners.indexOf(listener);

      if (index > -1) {
        _this.__listeners[index] = _this.__listeners[_this.__listeners.length - 1];
        _this.__listeners.length--;
      }
    };
  }; // Notify Cache subscribers about a change in the cache


  Cache.prototype.notify = function () {
    for (var _i = 0, _a = this.__listeners; _i < _a.length; _i++) {
      var listener = _a[_i];
      listener();
    }
  };

  return Cache;
}();

export default Cache;